import {useState} from 'react';

export const useDebounce = (debounceTime: number | undefined = 375): ((change: () => void) => void) => {
    const [timer, setTimer] = useState<null | ReturnType<typeof setTimeout>>(null);

    return (change: () => void): void => {
        if (timer) {
            clearTimeout(timer);
            setTimer(null);
        }
        setTimer(
            setTimeout(() => {
                change();
            }, debounceTime)
        );
    };
};
